import { defineStore } from 'pinia'

export const useTsIdStore = defineStore('tsIdStore', {
  state: () => ({
    tsId: null
  })
})
